import * as XLSX from 'xlsx';

// Exporta un Excel (.xlsx) real con una hoja por cada objeto `sheet`.
// Cada fila es un objeto JS: las claves se vuelven encabezados de columna
// (con acentos y espacios, se lee bien en Excel / LibreOffice / Sheets).
//
// sheets: [{ name: 'Movimientos', rows: [{ 'Fecha y hora': '…', … }], widths: { 'Fecha y hora': 18 } }]
export function exportWorkbook(fileName, sheets) {
  const wb = XLSX.utils.book_new();
  for (const s of sheets) {
    const rows = s.rows && s.rows.length ? s.rows : [{ '(sin registros)': '' }];
    const ws = XLSX.utils.json_to_sheet(rows);
    if (s.widths) {
      ws['!cols'] = Object.keys(rows[0]).map((k) => ({ wch: s.widths[k] || 16 }));
    }
    XLSX.utils.book_append_sheet(wb, ws, String(s.name || 'Hoja').slice(0, 31));
  }
  XLSX.writeFile(wb, fileName);
}
